<template>
  <!-- 編輯頁面本體-->
  <div class="incsall ">
    <!--刪除區塊-->
    <DeleteModal :deleteModal="deleteModal" @init="init()"></DeleteModal>
 
    <!--要有檢視權限-->
    <div v-if="pagepermission.isView">
      <div v-if="!detail">
        <!--列表及查詢區塊-->
          <b-row
            ><b-col>
              <b-form-input
                v-model="search.keywords"
                placeholder="請輸入關鍵字"
                maxlength="100"
              ></b-form-input></b-col
            >
            <b-col>
              <b-form-datepicker
                placeholder="請選擇開始日期"
                v-model="search.startDate"
                class="mb-2"
                :date-format-options="{ year: 'numeric', month: 'long', day: 'numeric' }"
              ></b-form-datepicker>
            </b-col>
            ~
            <b-col>
              <b-form-datepicker
                placeholder="請選擇結束日期"
                v-model="search.OverDate"
                class="mb-2"
                :date-format-options="{ year: 'numeric', month: 'long', day: 'numeric' }"
              ></b-form-datepicker>
            </b-col>
            <b-col>
              <b-form-select
                v-model="search.status"
                :options="statusSearchOptions"
                class="only-button-down"
              ></b-form-select></b-col
            >
            <b-col>
              <b-form-select
                v-model="search.langurage"
                :options="langSearchOptions"
                class="only-button-down"
              ></b-form-select></b-col
            >
            <b-col cols="2"
              ><b-button @click="cancelSearch" v-if="checkSearchIsEmpty()==true" title="清空查詢條件">
                <b-icon icon="x-circle"></b-icon></b-button
              ><b-button @click="init" title="開始查詢">
                <b-icon icon="search"></b-icon></b-button
            ></b-col>
            <b-col cols="2"
              ><b-button 
                @click="_go('?lang='+lang+'&PJID='+PJ_ID+'&modal='+modal+'&id=null')"
                v-if="pagepermission.isInsert"
                >新增</b-button
              ></b-col
            ></b-row
          >
          <b-table-simple>
            <b-thead>
              <b-tr>
                <b-th>語系</b-th>
                <b-th>問題</b-th>
                <b-th>上下架日期</b-th>
                <b-th>狀態</b-th>
                <b-th>異動人員</b-th>
                <b-th>異動日期</b-th>
                <b-th>修改</b-th
                >
              </b-tr>
            </b-thead>
            <b-tbody>
              <b-tr v-for="item in contentList" :key="item.id+'-'+ item.langurage">
                <b-td>{{ langSearchOptions.find(x => x.value == item.langurage).text }}</b-td>
                <b-td>
                  {{ htmlDecode(item.title) }}
                </b-td>
                <b-td>{{ dateFormat(item.startDate) }} ~ <br> {{ dateFormat(item.endDate) }}</b-td>
                <b-td>{{ statusOptions.find(x => x.value == item.deployStatus).text }}</b-td>
                <b-td>{{ item.modifierName }}</b-td>
                <b-td>{{ dateFormat(item.modifyDate) }}</b-td>
                <b-td class="btn_edit">
                  <b-button
                    variant="info"
                    class="mr-3"
                    @click="_go('?lang='+item.langurage+'&PJID='+PJ_ID+'&modal='+modal+'&id='+item.id)"
                    v-if="pagepermission.isUpdate"
                    >編輯</b-button
                  >
                  <a
                    href="javascript:"
                    class="btn_delete"
                    v-if="pagepermission.isDelete"
                    @click="functionDelete(item)"
                    ><img src="/images/backend/del_icon.png" alt="刪除icon"/></a
                ></b-td>
              </b-tr>
            </b-tbody>
          </b-table-simple>
          <div class="page mt-2">
            <span class="pagination-total">共 {{Math.ceil(pagination.rows/pagination.perPage)}} 頁．{{pagination.rows}}筆資料</span>
            <b-pagination
              class="pagination light-theme simple-pagination"
              v-model="pagination.page"
              :total-rows="pagination.rows"
              :per-page="pagination.perPage"
              aria-controls="my-table"
            ></b-pagination>
          </div>
      </div>
      <div v-else>
          <!--內容區塊-->
          <div class="incsal">
            <div class="btare">
              <div class="backrul">
                <a :href="'?lang='+lang+'&PJID='+PJ_ID+'&modal='+modal">返回查詢結果</a>
              </div>
            </div>
            
            <!--切換語系區塊-->
            <div class="language_div p-3 mb-2">
                <button id="toTw" :class="'btn '+(this.lang == '1' ?'btn-danger selected':'btn-secondary')" @click="toLang('tw')">中文版</button>
                <button id="toEn" :class="'btn '+(this.lang == '2' ?'btn-danger selected':'btn-secondary')" @click="toLang('en')">英文版</button>
            </div>

            <!--標題區塊-->
            <div class="title_div p-3 mb-2 bkbor">
                <label class="text-danger" for="title">{{(lang==1)?"中文":"英文"}}問題*</label>
                <b-form-input 
                    name="title"
                    placeholder="請輸入問題"
                    required
                    maxlength="200" v-model="contentDetail.title">
                </b-form-input>
            </div>

            <!--設定區塊-->
            <b-form-group class="status_div p-3 mb-2 bkbor" label-size="lg" >
                <b-row>
                    <b-col>
                        <label class="text-danger" for="startDate">上架時間*</label>
                        <b-form-datepicker 
                            name="startDate"
                            class="mb-2"  
                            clear-button
                            placeholder="選擇上架日期" 
                            v-model="contentDetail.startDate"
                            :date-format-options="{ year: 'numeric', month: 'long', day: 'numeric' }">
                        </b-form-datepicker>
                    </b-col>
                    <b-col>
                        <label for="endDate">下架時間</label>
                        <b-form-datepicker 
                            name="endDate"
                            class="mb-2"  
                            reset-button
                            reset-button-text="清除日期"
                            placeholder="選擇下架日期" 
                            v-model="contentDetail.endDate"
                            :date-format-options="{ year: 'numeric', month: 'long', day: 'numeric' }">
                        </b-form-datepicker>
                    </b-col>
                    <b-col>
                        <label class="text-danger" for="Displaystatus">發布狀態*</label>
                        <b-form-select 
                            name="Displaystatus"
                            class="only-button-down"
                            v-model="contentDetail.deployStatus"
                            :options="statusOptions">
                        </b-form-select>
                    </b-col>
                </b-row>
            </b-form-group>
            
            <!--主內容區塊-->
            <b-form-group label-size="lg" class="p-4 mb-2 bkmn mt-3">
                <!--內文-->
                <b-row>
                    <b-col>
                        <label>回答</label>
                        <TinyMceEditor id="vue-tinymce" v-model="contentDetail.description">

                        </TinyMceEditor>
                    </b-col>
                </b-row>
            </b-form-group>

            <!--後台系統紀錄區塊 (若無資料則不顯示)-->
            <b-form-group class="status_div p-3 mb-2 bkbor" label-size="lg" 
                v-if="contentDetail.creatorName ||contentDetail.modifierName">
                <!--建檔記錄-->
                <b-row 
                    v-if="contentDetail.creatorName">
                    <b-col>
                        <span>建檔紀錄：</span>
                        <!--建檔記錄格式 = 建檔帳號(建立時間 yyyy-mm-dd HH:MM:ss) -->
                        <span>{{contentDetail.creatorName}}({{ contentDetail.createDate }})</span>
                    </b-col>
                </b-row>
                <!--異動紀錄-->
                <b-row 
                    v-if="contentDetail.modifierName">
                    <b-col>
                        <span>異動紀錄：</span>
                        <!--異動記錄格式 = 異動帳號(異動時間 yyyy-mm-dd HH:MM:ss) -->
                        <span>{{contentDetail.modifierName}}({{ contentDetail.modifyDate }})</span>
                    </b-col>
                </b-row>
            </b-form-group>
            <div class="Operation_div"> 
              <b-button id="save_btn" 
                  class="btn btn-secondary"
                  v-if="pagepermission.isInsert || pagepermission.isUpdate" 
                  @click="save" >儲存</b-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import DeleteModal from "../../Tool/deleteModal.vue";
  import TinyMceEditor from "../../Tool/TinyMecEditor.vue";
  export default {
    components: {
      TinyMceEditor,
      DeleteModal,
    },
    data() {
      return {
        detail: false,
        //查詢條件
        search: { status: null, langurage: null },
        initSeach: false,
        //頁數設定
        pagination: {
          perPage: 10,
          page: 1,
          rows: 5,
        },
        contentList: [],
        contentDetail: {},
        //刪除模板
        deleteModal: {
          id: null,
          classes: null,
          parent: null,
          show: false,
          type: "FAQ",
        },
        //發布狀態查詢選項
        statusSearchOptions: [
          { value: null, text: '全部發布狀態' },
          { value: 1, text: '開啟' },
          { value: 2, text: '關閉' },
        ],
        //語系查詢選項
        langSearchOptions: [
          { value: null, text: '全部語系' },
          { value: 1, text: '中文版' },
          { value: 2, text: '英文版' },
        ],
        //發布狀態編輯選項
        statusOptions: [
          { value: null, text: '請選擇' },
          { value: 1, text: '開啟' },
          { value: 2, text: '關閉' },
        ],
        //權限編號
        PJ_ID:"",
        //類別編號
        typeId: "1",
        //文章編號
        id:"", 
        //語系
        lang:"1",
        //樣式編號
        modal:"4",
        //是否開啟刪除介面
        deleteConfirm: false,
        //單位權限
        pagepermission:{},
        
        //API設定區
        apiFAQ: (data) => this.userRequest.post("bicd/FAQ", data),
      };
    },
    props:["value"],
    computed: {},
    mounted() {
      this.init();
    },
    watch: {
      "$route.query"() {
        this.init();
      },
      "pagination.page"() {
        this.init();
      },
      value(){
          //初始化
          this.init();
      }, 
      //權限
      permission(){
          this.pagepermission = this.permission;
      }
    },
    methods: {
      async init() {
        //類別編號
        this.PJ_ID = this.value.PJID;
        //類別內部編號
        this.typeId = 1;
        //文章編號
        this.id = this.value.id;
        //語系
        this.lang = this.value.lang?this.value.lang : 1;
        //樣式編號
        this.modal = this.value.modal;
        
        //取得畫面權限
        this.getPermission(this.PJ_ID);

        this.initSeach = false; 

        if (this.id == undefined) {
          //查詢文章內容
          window.scrollTo(0, 0);
          this.detail = false;  
          this.initSeach = true;  
                        
          try {
            this.contentList = {};
            let jsonReq = {
              TYPE: "LIST",
              VerifyCode:this.PJ_ID,
              FAQ_SELECT: {
                langurage: this.search.langurage,
                typeId: this.typeId,
                keywords: this.search.keywords,
                startDate: this.search.startDate,
                endDate: this.search.endDate,
                deployStatus: this.search.status,
                pageIndex: this.pagination.page,
                pageSize: this.pagination.perPage,
              },
            };
            let resToken = await this.userRequest.post(
                "bicd/Token"
            ); 
            jsonReq.Token = resToken.data;
            let res = await this.userRequest.post(
                "bicd/FAQ",
                jsonReq
            );
            let json = JSON.parse(res.data);
            if (json.Status) {
                let jsonData = JSON.parse(json.Data);
                this.contentList = jsonData.outData;
                this.pagination.rows = jsonData.totalCount;
            }
          } catch (err) {
              console.log(err);
          }
          this.checkSearchIsEmpty();
        } else {
          //修改文章內容
          this.detail = true;  
          this.initSeach = false; 

          try {
            this.contentDetail = {};
            let jsonReq = {
              TYPE: "SELECT",
              VerifyCode:this.PJ_ID,
              FAQ_SELECT: {
                id: this.id,
                typeId: this.typeId,
                langurage: this.lang,
              },
            };
            let resToken = await this.userRequest.post(
                "bicd/Token"
            ); 
            jsonReq.Token = resToken.data;
            let res = await this.userRequest.post(
                "bicd/FAQ",
                jsonReq
            );
            let json = JSON.parse(res.data);
            if (json.Status) {
              let jsonData = JSON.parse(json.Data);
 
              if(jsonData) {
              this.contentDetail = jsonData;
              this.contentDetail.title = this.htmlDecode(this.contentDetail.title);
              } else {
                this.contentDetail = {};
                this.contentDetail = {
                    startDate: new Date().toISOString(),
                    linkMethod: '_self',
                    deployStatus: null,
                    sort: 1,
                    creatorName: sessionStorage.getItem("LoginName"),
                    createDate: new Date().toISOString(),
                    modifierName: sessionStorage.getItem("LoginName"),
                    modifyDate: new Date().toISOString(),
                };
              }
            }
          } catch (err) {
              console.log(err);
          }
        }
      },
      functionDelete(item) {
        this.deleteModal.show = true;
        this.deleteModal.id = item.id;
        this.deleteModal.type = "FAQ";
        this.deleteModal.langurage = this.lang;
        this.deleteModal.VerifyCode = this.PJ_ID;
      },
      save() {
        //將目前資訊整合，並送出
        let json_list = {
            id:(this.id)?Number(this.id):0,
              langurage: this.lang,
              typeId: this.typeId,
              model: this.modal,
              title: this.contentDetail.title,
              description: this.contentDetail.description,
              url: this.contentDetail.url,
              linkMethod: this.contentDetail.linkMethod,
              startDate: this.contentDetail.startDate,
              endDate: this.contentDetail.endDate,
              deployStatus: this.contentDetail.deployStatus,
              sort: this.contentDetail.sort,
        }
          let json = {
          TYPE: "SAVE",
            VerifyCode:this.PJ_ID,
          FAQ_UPDATE: json_list,
          };
        this.FunctionToken(this.functionSaveContent, json);
      },
      //新增/修改功能
      functionSaveContent(data) {
        this.apiFAQ(data)
          .then((res) => {
            let json = JSON.parse(res.data);
            if (json.Status) {
              this.$bvToast.toast("儲存成功", {
                title: "提示",
                solid: true,
              });
              this._go("?lang="+this.lang+"&PJID="+this.PJ_ID+"&modal="+ this.modal);
            } else {
              alert(this.Str_Replace(JSON.parse(json.Data), ",", "\r\n"));
            }
          })
          .catch((err) => {
            //console.log(err);
          });
      },
      cancelSearch () {
        this.search = {status: null,langurage: null};
        this.init();
      },
      //切換語系
      toLang(click_lang){
        
        if(click_lang == 'tw' && this.lang != '1'){
            //進入中文介面 
            if (this.isEdited){
                //確認是否不儲存就離開
                if(!confirm("還有尚未儲存的資料，請問是否直接離開")){
                    return;
                }
            }
            this._go("?PJID="+this.PJ_ID + "&typeId="+this.typeId +"&modal="+this.modal+((this.id != undefined && this.id != '')?"&id="+this.id:"")+"&lang=1");
            
        }else if(click_lang == 'en'&& this.lang != '2'){
            //進入英文介面
            if(this.isEdited){
                //確認是否不儲存就離開
                if(!confirm("還有尚未儲存的資料，請問是否直接離開")){
                    return;
                }
            }
            this._go("?PJID="+this.PJ_ID + "&typeId="+this.typeId +"&modal="+this.modal+((this.id != undefined && this.id != '')?"&id="+this.id:"")+"&lang=2");
        }
      },
    },
  };

</script>
